import React from 'react';
import { AboutSection } from '../components/sections/AboutSection';
interface NosotrosPageProps {
  onBack: () => void;
}
export function NosotrosPage({
  onBack
}: NosotrosPageProps) {
  return <main data-id="element-969" data-mp="u1m7og8kqmsq">
      <AboutSection onBack={onBack} data-id="element-970" data-mp="u1cbuc0ullf4" />
    </main>;
}